export const WAVE_DOT_RADIUS = 10;
export const WAVE_DOT_STROKE = 2;

export const WAVE_OFFSET_X_LEFT = 30 + WAVE_DOT_RADIUS + WAVE_DOT_STROKE;
export const WAVE_OFFSET_X_RIGHT = WAVE_DOT_RADIUS + WAVE_DOT_STROKE;
export const WAVE_OFFSET_Y = WAVE_DOT_RADIUS + WAVE_DOT_STROKE;

export const WAVE_WIDTH = 360;  // full circle in [deg]
export const WAVE_HEIGHT = 100;
export const WAVE_SVG_WIDTH = WAVE_OFFSET_X_LEFT + WAVE_WIDTH + WAVE_OFFSET_X_RIGHT;
export const WAVE_SVG_HEIGHT = WAVE_OFFSET_Y + WAVE_HEIGHT + WAVE_OFFSET_Y;

export const WAVE_VIEWBOX = `0 0 ${WAVE_SVG_WIDTH} ${WAVE_SVG_HEIGHT}`;   // min-x, min-y, width and height
